import { SPACE_UPLOADABLE_MIME_TYPES, SpaceFileMimeType } from 'shared';

type UploadableMimeType = (typeof SPACE_UPLOADABLE_MIME_TYPES)[number];

// Narrows the system file picker; extensions too, since some systems report no type for a file.
export const SPACE_UPLOAD_ACCEPT: Record<UploadableMimeType, string[]> = {
  [SpaceFileMimeType.CSV]: ['.csv'],
  [SpaceFileMimeType.DOCX]: ['.docx'],
  [SpaceFileMimeType.JPEG]: ['.jpg', '.jpeg'],
  [SpaceFileMimeType.PDF]: ['.pdf'],
  [SpaceFileMimeType.PNG]: ['.png'],
  [SpaceFileMimeType.XLS]: ['.xls'],
  [SpaceFileMimeType.XLSX]: ['.xlsx'],
};
